/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_cake } from './social/cake.icon';
import { icon_domain } from './social/domain.icon';
import { icon_group_add } from './social/group_add.icon';
import { icon_group } from './social/group.icon';
import { icon_location_city } from './social/location_city.icon';
import { icon_mood } from './social/mood.icon';
import { icon_mood_bad } from './social/mood_bad.icon';
import { icon_notifications } from './social/notifications.icon';
import { icon_notifications_active } from './social/notifications_active.icon';
import { icon_notifications_off } from './social/notifications_off.icon';
import { icon_notifications_none } from './social/notifications_none.icon';
import { icon_notifications_paused } from './social/notifications_paused.icon';
import { icon_pages } from './social/pages.icon';
import { icon_party_mode } from './social/party_mode.icon';
import { icon_people } from './social/people.icon';
import { icon_people_outline } from './social/people_outline.icon';
import { icon_person } from './social/person.icon';
import { icon_person_add } from './social/person_add.icon';
import { icon_person_outline } from './social/person_outline.icon';
import { icon_plus_one } from './social/plus_one.icon';
import { icon_poll } from './social/poll.icon';
import { icon_school } from './social/school.icon';
import { icon_sentiment_dissatisfied } from './social/sentiment_dissatisfied.icon';
import { icon_sentiment_neutral } from './social/sentiment_neutral.icon';
import { icon_public } from './social/public.icon';
import { icon_sentiment_satisfied } from './social/sentiment_satisfied.icon';
import { icon_sentiment_very_dissatisfied } from './social/sentiment_very_dissatisfied.icon';
import { icon_sentiment_very_satisfied } from './social/sentiment_very_satisfied.icon';
import { icon_share } from './social/share.icon';
import { icon_whatshot } from './social/whatshot.icon';
var icons = {
  "cake" : icon_cake,
"domain" : icon_domain,
"group_add" : icon_group_add,
"group" : icon_group,
"location_city" : icon_location_city,
"mood" : icon_mood,
"mood_bad" : icon_mood_bad,
"notifications" : icon_notifications,
"notifications_active" : icon_notifications_active,
"notifications_off" : icon_notifications_off,
"notifications_none" : icon_notifications_none,
"notifications_paused" : icon_notifications_paused,
"pages" : icon_pages,
"party_mode" : icon_party_mode,
"people" : icon_people,
"people_outline" : icon_people_outline,
"person" : icon_person,
"person_add" : icon_person_add,
"person_outline" : icon_person_outline,
"plus_one" : icon_plus_one,
"poll" : icon_poll,
"school" : icon_school,
"sentiment_dissatisfied" : icon_sentiment_dissatisfied,
"sentiment_neutral" : icon_sentiment_neutral,
"public" : icon_public,
"sentiment_satisfied" : icon_sentiment_satisfied,
"sentiment_very_dissatisfied" : icon_sentiment_very_dissatisfied,
"sentiment_very_satisfied" : icon_sentiment_very_satisfied,
"share" : icon_share,
"whatshot" : icon_whatshot,
};
export { icons };
